module.exports = __webpack_public_path__ + "static/media/smile.d9b69149.svg";